import { Outlet } from "react-router-dom"
import { Sidebar } from "./Sidebar"
import { ExecutiveHeader } from "./ExecutiveHeader"

export function AdminLayout() {
  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#F8FAFC" }}>
      <Sidebar />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
        <ExecutiveHeader />
        <main style={{ flex: 1, padding: "28px 32px", overflowY: "auto" }}>
          <Outlet />
        </main>
      </div>
    </div>
  )
}